export default __webpack_public_path__ + "static/media/step4.61dc1388.webp";